var map = {
	"./1-unsplash.jpg": "d3e0",
	"./2-unsplash.jpg": "a3bd",
	"./3-unsplash.jpg": "f7ef",
	"./4-unsplash.jpg": "9116",
	"./InAction.gif": "d942",
	"./JanisRozenfelds.jpg": "12f2",
	"./SelectFromMenu.gif": "2d68",
	"./beta-unsplash-01.jpg": "524e",
	"./beta-unsplash-02.jpg": "bdbe",
	"./beta-unsplash-03.jpg": "158f",
	"./how-to-download.gif": "431e",
	"./how-to-get-unsplash-photo-id.gif": "8da3",
	"./macShortCut.gif": "c2c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9795";